module.exports = __webpack_public_path__ + "static/media/ina.014d09d1.png";